import { all } from "redux-saga/effects";

import {
  stockAuditCreateWatcher,
  stockAuditDeleteWatcher,
  stockAuditEditWatcher,
  stockAuditLoadFiltersWatcher,
  stockAuditTableWatcher,
  stockAuditViewWatcher,
  stockDetailsBatchDropDownWatcher,
  stockDetailsBatchUpdateWatcher,
  stockDetailsBatchViewWatcher,
  stockDetailsItemViewWatcher,
  stockDetailsWarehouseLocationWatcher,
  stockDetailsItemsFetchWatcher,
} from "../stock-details-saga";

export default function* stockAuditRootSaga() {
  yield all([
    stockDetailsItemsFetchWatcher(),
    stockDetailsBatchViewWatcher(),
    stockDetailsBatchDropDownWatcher(),
    stockDetailsBatchUpdateWatcher(),
    stockDetailsItemViewWatcher(),
    stockDetailsWarehouseLocationWatcher(),
    stockAuditTableWatcher(),
    stockAuditLoadFiltersWatcher(),
    stockAuditCreateWatcher(),
    stockAuditDeleteWatcher(),
    stockAuditViewWatcher(),
    stockAuditEditWatcher(),
  ]);
}
